import React from "react";
import { Route, RouteProps } from "react-router-dom";

const GrailedRoute = (props: RouteProps) => {
  return <Route {...props} />;
};

export default GrailedRoute;
